module.exports = __webpack_public_path__ + "sa.svg?e5a120b5d06e90050eee5c658308e811";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sa.svg
// module id = 1368
// module chunks = 27